module.exports = "/_next/static/files/1aa8ed1eaaa6a2bef88c5f2aa3d45051.jpg";